<template>

  <div class="all">
    <headercon></headercon>
    <div class="anniu">
      <img :src="img1"
           alt=""
           @click="go"
           class="button">
      <div class="info">
        <ul>
          <li v-for="(list,i) in goodsList"
              :key="i">
            <div class="row">
              <div class="col2">
                <div class="jobname">{{list.name}}</div>
                <div class="job-map">工作地点：{{list.place}} </div>
                <div class="job-map">招聘人数：{{list.number}} </div>
                <a class="job-send"
                   @click="go2"
                   target="_Blank">投递简历 ></a>
              </div>
              <div class="title">任职资格:</div>
              <div class="col5"
                   v-html="list.qualif">
              </div>
              <div class="title1">岗位职责:</div>
              <div class="col6"
                   v-html="list.resp">
              </div>

            </div>
          </li>

        </ul>
      </div>
      <img :src="img2"
           alt=""
           @click="go1"
           class="button1">
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import headercon from './header'
export default {
  components: {
    headercon
  },
  data () {
    return {
      img: require('../assets/componylogo.png'),
      img1: require('../assets/buttonl.png'),
      img2: require('../assets/buttonr.png'),
      text: '首页',
      text1: '产品与服务',
      text2: '企业动态',
      text3: '资质荣誉',
      text4: '关于我们',
      goodsList: null
    }
  },
  created () {
    this.prodId = this.$route.params.prodId
    this.getlist(this.$route.params.prodId)
  },
  methods: {
    getlist () {
      const url = this.HOST + '/openApi/postsList'
      console.log('123')
      console.log(url)
      const that = this
      axios.get(url, { params: {
        prodId: this.prodId,
        dataType: 'jsonp',
        crossDomain: true } })
        .then(function (response) {
          that.goodsList = response.data.rows
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    go () {
      this.$router.push({ path: '/map' })
    },
    go1 () {
      this.$router.push({ path: '/aboutus' })
    },
    go2 () {
      this.$router.push({ path: '/toudi' })
    }
  }
}
</script>

// <style scoped lang="less">
.all {
  background: url("../assets/recruit.png");
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  min-width: 1199px;
  .anniu {
    display: flex;
    width: 100%;
    height: 70%;
    .button {
      margin-top: 19.5%;
      margin-left: 3%;
      width: 2%;
      height: 20%;
      text-align: center;
      line-height: 28px;
      background: linear-gradient(to right, #d5edfb, #eeffff);
      border: none;
      font-size: 80px;
      color: #62c3d0;
    }

    .info {
      position: absolute;
      margin-left: 10%;
      top: 35%;
      height: 60%;
      width: 70%;
      overflow-y: auto;
      overflow-x: hidden;
      position: relative;
      padding: 0px 10px;
      background: linear-gradient(to left, #d5edfb, #eeffff);
      text-align: left;
      ul {
        width: 100%;
      }
      li {
        width: 100%;
        border-top: 2px #999999 solid;
        padding: 10px 0px 20px 0px;
      }
      .jobtitle {
        color: #333333;
        font-size: 14px;
        font-weight: bold;
      }
      .jobtxt {
        color: #333333;
        font-size: 12px;
      }
      .jobname {
        color: #051d6d;
        font-size: 15px;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .job-map {
        font-size: 15px;
        color: #750a83;
        line-height: 20px;
      }
      .job-send {
        margin-top: 40px;
        color: #750a83;
        font-size: 15px;
      }
      .job-more {
        display: inline-block;
        vertical-align: middle;
        margin-left: 5px;
        width: 16px;
        height: 11px;
      }
      .title {
        display: block;
        margin-left: 48%;
        margin-top: -90px;
      }
      .col5 {
        display: block;
        margin-left: 48%;
        margin-top: 0px;
        font-size: 13px;
        width: 45%;
      }
      .title1 {
        display: block;
        margin-left: 48%;
        margin-top: 20px;
      }
      .col6 {
        display: block;
        margin-left: 48%;
        margin-top: 0px;
        font-size: 13px;
        width: 45%;
      }
      .col4 {
        display: block;
        margin-left: 680px;
        margin-top: -110px;
      }
    }
  }
  /deep/ .li5 {
    list-style-type: none;
    float: left;
    border-radius: 25px;
    background: #fff;
    width: 100px;
    height: 30px;
    text-decoration: none;
    text-align: center;
    line-height: 30px;
    a {
      color: #757575;
      text-decoration: none;
    }
  }
}
@media only screen and (min-width: 1781px) {
  .button1 {
    position: absolute;
    right: 3%;
    margin-top: 19.5%;
    width: 2%;
    height: 15%;
    text-align: center;
    line-height: 28px;
    background: linear-gradient(to left, #d5edfb, #eeffff);
    border: none;
    font-size: 80px;
    color: #62c3d0;
  }
}
@media only screen and (min-width: 1601px) and (max-width: 1780px) {
  .button1 {
    position: absolute;
    right: 3%;
    margin-top: 19.5%;
    width: 2%;
    height: 15%;
    text-align: center;
    line-height: 28px;
    background: linear-gradient(to left, #d5edfb, #eeffff);
    border: none;
    font-size: 80px;
    color: #62c3d0;
  }
}
@media only screen and (min-width: 1421px) and (max-width: 1600px) {
  .button1 {
    position: absolute;
    right: 3%;
    margin-top: 19.5%;
    width: 2%;
    height: 15%;
    text-align: center;
    line-height: 28px;
    background: linear-gradient(to left, #d5edfb, #eeffff);
    border: none;
    font-size: 80px;
    color: #62c3d0;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1420px) {
  .button1 {
    position: absolute;
    right: 3%;
    margin-top: 19.5%;
    width: 2%;
    height: 15%;
    text-align: center;
    line-height: 28px;
    background: linear-gradient(to left, #d5edfb, #eeffff);
    border: none;
    font-size: 80px;
    color: #62c3d0;
  }
}
@media only screen and (max-width: 1200px) {
  .button1 {
    position: absolute;
    left: 1100px;
    top: 300px;
    width: 24px;
    height: 73px;
    text-align: center;
    line-height: 28px;
    background: linear-gradient(to left, #d5edfb, #eeffff);
    border: none;
    font-size: 80px;
    color: #62c3d0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/recruit.vue